import { render } from "./tuesday-afternoon.vue?vue&type=template&id=7d9f24eb"
import script from "./tuesday-afternoon.vue?vue&type=script&lang=js"
export * from "./tuesday-afternoon.vue?vue&type=script&lang=js"
script.render = render

export default script